import React, { ReactNode } from 'react';
import { Element } from '@/components/card/CardTitle/CardTitle.styles';
import { Title } from '@/components/typography';
import { TitleProps } from '@/components/typography/Title/Title';

export interface CardTitleProps extends TitleProps {
  className?: string;
  children?: ReactNode;
}

const CardTitle = ({ children, ...props }: CardTitleProps) => {
  return (
    <Element>
      <Title weight="semi_bold" size="md" color="secondary_500" {...props} as="h2">
        {children}
      </Title>
    </Element>
  );
};

export default CardTitle;
